(function(){
  function waitFor(selector, cb, maxTries) {
    var tries = 0;
    var iv = setInterval(function(){
      var el = document.querySelector(selector);
      if (el) { clearInterval(iv); cb(el); }
      if (++tries > (maxTries || 100)) clearInterval(iv);
    }, 100);
  }

  var BUNDLE_DATA = {
    1: { price: '$127.900', name: '1 KIT · PRECIO INDIVIDUAL' },
    2: { price: '$205.800', name: '2 KITS · AHORRAS $50.000' },
    3: { price: '$287.700', name: '3 KITS · AHORRAS $96.000' }
  };

  window.selectBundle = function(qty) {
    var cards = document.querySelectorAll('.bundle-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.remove('selected');
    var card = document.querySelector('.bundle-card[data-qty="' + qty + '"]');
    if (card) card.classList.add('selected');

    var data = BUNDLE_DATA[qty];
    var qtyInputs = document.querySelectorAll('.rsi-form input[name="quantity"]');
    for (var q = 0; q < qtyInputs.length; q++) qtyInputs[q].value = qty;

    // V5.59: btn-sol label NUNCA cambia con bundle. Siempre precio 1u.

    var ctaPrice = document.getElementById('ctaPrice');
    var ctaBundleName = document.getElementById('ctaBundleName');
    if (ctaPrice) ctaPrice.textContent = data.price;
    if (ctaBundleName) ctaBundleName.textContent = data.name;
  };

  var deadline = null;
  function getDeadline() {
    if (deadline && deadline > Date.now()) return deadline;
    try {
      var stored = localStorage.getItem('calmapaw_cd_v1');
      if (stored) {
        var d = new Date(stored);
        if (!isNaN(d.getTime()) && d.getTime() > Date.now()) {
          deadline = d.getTime();
          return deadline;
        }
      }
    } catch(e) {}
    var newD = new Date(Date.now() + 24 * 60 * 60 * 1000);
    deadline = newD.getTime();
    try { localStorage.setItem('calmapaw_cd_v1', newD.toISOString()); } catch(e) {}
    return deadline;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var ms = getDeadline() - Date.now();
    if (ms <= 0) { deadline = null; ms = getDeadline() - Date.now(); }
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
    var t1 = document.getElementById('urgencyTimer');
    var t2 = document.getElementById('ctaTimer');
    if (t1) t1.textContent = txt;
    if (t2) t2.textContent = txt;
  }
  setInterval(tick, 1000);
  tick();
  setTimeout(tick, 500); setTimeout(tick, 1500); setTimeout(tick, 3000);

  window.scrollBundles = function() {
    var el = document.getElementById('bundles');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  window.toggleFaq = function(el) {
    el.parentElement.classList.toggle('open');
  };

  function initFloat() {
    var hero = document.querySelector('.hero');
    var floater = document.getElementById('floatCta');
    if (!hero || !floater) return;
    window.addEventListener('scroll', function() {
      var showAt = hero.offsetTop + hero.offsetHeight;
      if (window.scrollY > showAt) { floater.style.display = 'block'; floater.classList.add('show'); }
      else { floater.style.display = 'none'; floater.classList.remove('show'); }
    }, { passive: true });
  }

  function initAll() {
    tick();
    initFloat();
    selectBundle(1);
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(initAll, 100);
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  setTimeout(initAll, 2000);
})();